export default __webpack_public_path__ + "static/SRF 0085 - Product Specifications & Technical Data-72a7f09448afaab7398d00bdcbba6180.pdf";